<template>
  <main>
    <!-- <section class="section--full section--full--banner overlayed"> -->
    <section id="parallax" class="section--full section--banner" @mousemove="parallax">
      <video autoplay muted playsinline loop class="section__video">
        <source src="@/assets/video/virtual.mp4" type="video/mp4">
      </video>
    </section>
    <section class="container container--short">
      <div class="container--white">
        <h2 class="heading-detail">Virtual Hangout & Video Challange by Klaklik</h2>
        <div class="details">
          <p class="description">
            Dalam rangka menyambut HUT MNC Group ke 32. Klaklik mempersembahkan rangkaian virtual Fun Hangout dengan para talent  dari series favorit, yaitu para pemeran dari sinetron-sinetron nomor 1 MNC seperti Ikatan Cinta, Putri untuk Pangeran, IPA & IPS, Amanah Wali, dan Kuraih Bintang mulai 31 Oktober sampai 5 November 2021. Ikutan juga video challenge berhadiah jutaan rupiah! Syarat dan ketentuan berlaku.
          </p>
        </div>

        <div class="details">
          <img class="md-image" src="@/assets/images/FUN HANGOUT HUT MNC NI BOS1 copy 5.jpg" alt="">
        </div>

        <div class="details">
          <div class="font-title">Ikuti Video Challenge untuk beberapa program ini. Berhadiah jutaan rupiah!</div>
          <br>
          <ol class="mg-left-35">
            <li class="description list-block">
              Satu Rasa “Ikatan Cinta”
              <br>
              Ekspresikan aspirasi atau perasaan kamu terhadap serial "Ikatan Cinta"!
            </li>
            <li class="description list-block">
              Parodi "Amanah Wali"
              <br>
              Bikin parodi dari adegan "Amanah Wali" yang paling seru versi kamu! 
            </li>
            <li class="description list-block">
              Bicara PUPA
              <br>
              Buktikan seberapa kenal kamu dengan karakter atau pemeran sinetron "Putri Untuk Pangeran"!
            </li>
            <li class="description list-block">
              Ceritamu & Makananmu
              <br>
              Dokumentasikan makanan kamu dan cerita menarik di baliknya!
            </li>
          </ol>
        </div>

        <div class="details">
          <div class="font-title">Syarat & Ketentuan</div>
          <br>
          <ol class="mg-left-35">
            <li class="description list-block">Buat video se-kreatif mungkin!</li>
            <li class="description list-block">
             Lomba ini tidak dipungut biaya apapun.
            </li>
            <li class="description list-block">
              Video tidak diperkenankan mengandung unsur SARA, pornografi, kekerasan, dan muatan negatif lainnya. 
            </li>
            <li class="description list-block">
              Submit video di aplikasi <a class="link" target="_blank" href="https://www.klaklik.com">Klaklik</a>
            </li>
            <li class="description list-block">
              Video submission berakhir pada 15 November 2021
            </li>
          </ol>
        </div>

        <div class="details">
          <div class="font-title">Cara Submit Video :</div>
          <br>
          <ul class="mg-left-35">
            <li class="description list-block">
              Download aplikasi <a class="link" href="https://www.klaklik.com">Klaklik</a>
            </li>
            <li class="description list-block">
              Lengkapi data yang valid sesuai KTP
            </li>
            <li class="description list-block">
              Pilih fitur CIRCLE, lalu klik Be The Artis
            </li>
            <li class="description list-block">
              Klik tanda upload dan pilih kategori apa yang mau diikuti
            </li>
          </ul>
        </div>

        <div class="details">
          <div class="font-title">Hadiah</div>
          <br>
          <p class="description">Masing-masing kategori akan memilih 3 video pemenang;</p>
          <br>
          <ul class="mg-left-35 list-short">
            <li class="description list-block">
              <div class="flex flex--flex--grid">
                <span>IKATAN CINTA @ Rp. 1.000.000,- x 3 		</span>
                <span>= Rp. 3.000.000,-</span>
              </div>
            </li>
            <li class="description list-block">
              <div class="flex flex--flex--grid">
                <span>PUTRI UNTUK PANGERA @ Rp. 1.000.000 x 3 </span>
                <span>= Rp. 3.000.000,-</span>
              </div>
            </li>
            <li class="description list-block">
              <div class="flex flex--flex--grid">
                <span>AMANAH WALI @ Rp. 1.000.000,- x 3</span>
                <span>	= Rp. 3.000.000,-</span>
              </div>
            </li>
            <li class="description list-block">
              <div class="flex flex--flex--grid">
                <span>FOOD STORY @ Rp. 1.000.000,- x 3
                </span><span>	= Rp. 3.000.000,-</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- <div class="grid grid--three details">
          <div>
            <img src="https://images.unsplash.com/photo-1579227114347-15d08fc37cae?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" alt="">
          </div>
        </div> -->

        <div class="register details">
          <button>
            <a href="https://www.klaklik.com">
              Download Klaklik
            </a>
          </button>
        </div>

      </div>
    </section>
  </main>
</template>

<script>
import parallax from '@/commons/parallax.js'

export default {
  name: 'DetailVirtual',
  methods: {
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    }
  }
}
</script>